import * as React from 'react';
import { captureError } from '@/lib/sentry';

interface State {
  hasError: boolean;
  error: Error | null;
}

interface Props {
  children: React.ReactNode;
}

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    captureError(error, { componentStack: info.componentStack ?? '' });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-bg p-4">
          <div className="max-w-md space-y-3 border border-border bg-bg-elevated p-6 text-center">
            <p className="text-6xl font-bold text-destructive">⚠</p>
            <h1 className="text-xl font-bold">Algo salió mal</h1>
            <p className="text-sm text-text-secondary">
              Ocurrió un error inesperado. Recarga la página o vuelve al inicio.
            </p>
            <p className="rounded-md bg-muted p-2 font-mono text-xs break-all">
              {this.state.error?.message ?? 'Sin detalles'}
            </p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="rounded-md bg-primary px-4 py-2 text-primary-foreground hover:bg-primary/90"
            >
              Recargar página
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}